// Pure helpers for the manual Tiered / Non-Tiered Customer Performance
// adjustments feature. Kept free of React/redux so the endpoint->dataType
// mapping, payload building, validation, and drill-down row flags can be unit
// tested in isolation. See CustomerPerformanceManualAdd.pdf + api.txt.

// Fallback metric-type options. The live list comes from the
// ManualPerformanceOptions API (metricTypes), but this fixes the value order
// and provides labels if the API list is unavailable.
export const METRIC_TYPES = [
  { value: "UncoveredLabor", label: "Uncovered Job" },
  { value: "UncoveredMaterialStockout", label: "Uncovered Material Stockout" },
  { value: "Quality", label: "Quality" },
  { value: "Shortage", label: "Shortage" },
];

// The widget endpoint decides the dataType — the user never picks it.
export const dataTypeForEndpoint = (endpoint) =>
  endpoint === "TieredCustomerPerformance" ? "Tiered" : "NonTiered";

// Client-side guard mirroring the server's 400 messages so the user gets
// immediate feedback before the round-trip.
export const validateManualEntry = (form) => {
  if (!form || !form.metricType) return "Select what you would like to add.";
  if (form.contactInfoId == null || form.contactInfoId === "")
    return "Select a property.";
  return null;
};

// AddManualPerformanceEntry request body. entryDate stays null so the entry
// counts from today (per api.txt).
export const buildManualEntryPayload = (form, dataType) => ({
  metricType: form.metricType,
  dataType,
  contactInfoId: form.contactInfoId,
  unitNumber: form.unitNumber || "",
  jobNumber: form.jobNumber || "",
  reason: form.reason || "",
  description: form.description || "",
  entryDate: null,
});

// Drill-down row was typed by hand via this feature.
export const isManualRow = (row) => !!(row && row.isManualEntry === true);

// SetPerformanceCountExclusion request body. Works on system and manual rows;
// always send the row's own exclusion source, never a derived one.
export const buildExclusionPayload = (row, isExcluded, note = "") => ({
  sourceType: row.exclusionSourceType,
  sourceId: row.exclusionSourceId,
  isExcluded,
  note: note || "",
});
